// Shared by both forks.
import React, { createContext, useContext } from 'react';

// The old fork has no search-by-image panel, so it provides a no-op for `openSearchByImage`.
export type SpotlightDropdownContextValue = {
	isDropdownOpen: boolean;
	openSpotlightDropdown: () => void;
	closeSpotlightDropdown: () => void;
	refInput: React.RefObject<HTMLInputElement | null>;
	openSearchByImage: () => void;
};

export const SpotlightDropdownContext = createContext<SpotlightDropdownContextValue | null>(null);

export function useSpotlightDropdownContext() {
	const context = useContext(SpotlightDropdownContext);

	if (!context) {
		throw new Error('useSpotlightDropdownContext must be used within a SpotlightStateProvider');
	}

	return context;
}
